//react
import React from 'react';

// 3rd party editor
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'font-awesome/css/font-awesome.css';
import FroalaEditor from 'react-froala-wysiwyg';

class ContentEditor extends React.Component{
    constructor(props) {
      super(props);

      this.state = {
        model: props.value
      };

      this.handleModelChange = this.handleModelChange.bind(this);
    }

    handleModelChange (updatedModel) {
        
        this.setState({
          model: updatedModel
        });

        this.props.onChange(updatedModel);
      }

    render() {

     
        return (
            <FroalaEditor
              model={this.state.model}
              onModelChange={this.handleModelChange}
           />
        );
    }
}


export default ContentEditor;



// WEBPACK FOOTER //
// ./src/components/ContentEditor/ContentEditor.jsx